<template>
  <div class="mains">
    <div class="campus">
      教务管理
      <span>></span>
      <router-link to="student">学员管理</router-link>
    </div>

    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">正式学员</div>
          <el-button type="primary" class="buttons" @click="addStudent1">
            <span>+</span> 新建学员
          </el-button>
          <!--<el-button type="primary" class="buttons">导出学员</el-button>
          <el-button type="primary" class="buttons">导入学员</el-button>-->
          <el-button type="primary" class="buttons" @click="dels">批量删除</el-button>
          <div class="sousuo">
            <span>状态：</span>
            <el-dropdown>
              <el-button type="primary" class="xuanze">
                {{ xuanzezhuantai1 }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="student_zhuantai dropdowns" slot="dropdown">
                <el-dropdown-item @click.native="guanli2(item)" v-for="(item, index) in xuanzezhuantai" :key="index">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span>班级：</span>
            <el-dropdown>
              <el-button type="primary" class="xuanze">
                {{ xuanzebanji1 }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="dropdowns" slot="dropdown">
                <el-dropdown-item @click.native="guanli3(item)" v-for="(item, index) in xuanzebanji" :key="index">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span>学员账号：</span>
            <el-input v-model="orgnames" @keyup.13.native="selectStudentPage" placeholder="请输入学员姓名"></el-input>
            <el-button type="primary" class="buttons" @click="selectStudentPage()">查 询</el-button>
          </div>
          <el-dialog title="新建学员" :visible.sync="addStudents" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="forms" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="学员姓名" prop="name">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms.name" placeholder="请输入学员的姓名"></el-input>
                </el-form-item>
                <el-form-item label="学员班级" prop="classid">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-dropdown class="student_dropdown">
                    <el-button type="primary" class="xuanze1 xzbz" :class="yanse2 ? 'zt1' : ''">
                      {{ xuanze3 }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu class="student_dropdown dropdownss" slot="dropdown">
                      <el-dropdown-item @click.native="guanli(item)" v-for="(item, index) in banji1" :key="index">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="性别" class="xingbie">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-radio-group v-model="forms.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms.phone" placeholder="请输入学员的联系方式"></el-input>
                </el-form-item>
                <el-form-item label="学员生日" prop="birthday">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-date-picker v-model="forms.birthday" type="date" placeholder="选择学员出生日期" class="chushen"></el-date-picker>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="addStudent">确定</el-button>
                  <el-button @click="quxiao">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="编辑学员" :visible.sync="addStudentss" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="forms1" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="学员姓名" prop="name">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms1.name" placeholder="请输入学员的姓名"></el-input>
                </el-form-item>
                <el-form-item label="学员班级" prop="classid">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-dropdown class="student_dropdown">
                    <el-button type="primary" class="xuanze1 xzbz" :class="yanse3 ? 'zt1' : ''">
                      {{ xuanze1 }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu class="student_dropdown dropdownss" slot="dropdown">
                      <el-dropdown-item @click.native="guanli1(item)" v-for="(item, index) in banji1" :key="index">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="性别" class="xingbie">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-radio-group v-model="forms1.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms1.phone" placeholder="请输入学员的联系方式"></el-input>
                </el-form-item>
                <el-form-item label="学员生日" prop="birthday">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-date-picker v-model="forms1.birthday" type="date" placeholder="选择学员出生日期" class="chushen"></el-date-picker>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="updateStudent">确定</el-button>
                  <el-button @click="quxiao">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="学员信息" :visible.sync="addStudentsss" width="600px">
            <el-row class="chakanss">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  学员姓名：
                  <span>{{ form.name }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  出生日期：
                  <span>{{ form.birthday }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row class="chakanss">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  学员性别：
                  <span>{{ form.sex }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  联系方式：
                  <span>{{ form.phone }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row class="chakanss">
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  所在班级：
                  <span>{{ xuanze1 }}</span>
                </div>
              </el-col>
            </el-row>
          </el-dialog>
          <div class="zsbg zsbg_1">
            <el-table :data="tableData" border style="width: 100%" @select="handleSelectionChange" @select-all="fanxuan">
              <el-table-column type="selection" width="57" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="学员姓名" max-width="360">
                <template slot-scope="scope">
                  <el-link @click="chakan(scope.row.id)">{{
                    scope.row.name
                  }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="className" label="所在班级"></el-table-column>
              <el-table-column prop="birthday" label="出生日期"></el-table-column>
              <el-table-column prop="showCreateTime" label="创建时间"></el-table-column>
              <el-table-column prop="phone" label="联系方式">
                <template slot-scope="scope">
                  <el-link>{{ scope.row.phone }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="acount_status" label="账号状态"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="stData">
                  <el-button type="text" class="caozuo" @click="getStudentById(stData.row.id)">编辑</el-button>
                  <el-button type="text" class="caozuo" @click="deleteStudent(stData.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">报名学员</div>
          <el-button type="primary" class="buttons" @click="addEnrollStudent1">
            <span>+</span> 新建学员
          </el-button>
          <el-button type="primary" class="buttons" @click="del1s">批量删除</el-button>
          <!--<el-button type="primary" class="buttons">导出学员</el-button>
          <el-button type="primary" class="buttons">导入学员</el-button>-->
          <div class="sousuo">
            <span>状态：</span>
            <el-dropdown>
              <el-button type="primary" class="xuanze">
                {{ baomingzhuantai1 }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="student_zhuantai1 dropdowns" slot="dropdown">
                <el-dropdown-item @click.native="guanli2_1(item)" v-for="(item, index) in banji3" :key="index">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span>学员账号：</span>
            <el-input v-model="orgnamess" @keyup.13.native="selectEnrollStudentPage" placeholder="请输入学员姓名"></el-input>
            <el-button type="primary" class="buttons" @click="selectEnrollStudentPage()">查 询</el-button>
          </div>
          <el-dialog title="新建学员" :visible.sync="addEnrollStudents" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="form" :model="form" :rules="FormRuless" label-width="5.20833vw">
                <el-form-item label="学员姓名" prop="name">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form.name" placeholder="请输入学员的姓名"></el-input>
                </el-form-item>
                <el-form-item label="学员状态" prop="classid">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-dropdown class="student_dropdown">
                    <el-button type="primary" class="xuanze1 xzbz" :class="yanse1 ? 'zt1' : ''">
                      {{ xuanze4 }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu class="student_dropdown dropdownss" slot="dropdown">
                      <el-dropdown-item @click.native="guanli_1(item)" v-for="(item, index) in banji3" :key="index">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="性别" class="xingbie">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-radio-group v-model="form.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form.phone" placeholder="请输入学员的联系方式"></el-input>
                </el-form-item>
                <el-form-item label="学员生日" prop="birthday">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-date-picker v-model="form.birthday" type="date" placeholder="选择学员出生日期" class="chushen"></el-date-picker>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="addEnrollStudent">确定</el-button>
                  <el-button @click="quxiao1">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="编辑学员" :visible.sync="addEnrollStudentss" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="form" :model="form1" :rules="FormRuless" label-width="5.20833vw">
                <el-form-item label="学员姓名" prop="name">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form1.name" placeholder="请输入学员的姓名"></el-input>
                </el-form-item>
                <el-form-item label="学员状态" prop="classid">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-dropdown class="student_dropdown">
                    <el-button type="primary" class="xuanze1 xzbz" :class="yanse ? 'zt1' : ''">
                      {{ xuanze5 }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu class="student_dropdown dropdownss" slot="dropdown">
                      <el-dropdown-item @click.native="guanli1_1(item)" v-for="(item, index) in banji3" :key="index">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="性别" class="xingbie">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-radio-group v-model="form1.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form1.phone" placeholder="请输入学员的联系方式"></el-input>
                </el-form-item>
                <el-form-item label="学员生日" prop="birthday">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-date-picker v-model="form1.birthday" type="date" placeholder="选择学员出生日期" class="chushen"></el-date-picker>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="updateEnrollStudent">确定</el-button>
                  <el-button @click="quxiao1">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="学员信息" :visible.sync="addStudentsss1" width="600px">
            <el-row class="chakanss">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  学员姓名：
                  <span>{{ form.name }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  出生日期：
                  <span>{{ form.birthday }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row class="chakanss">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  学员性别：
                  <span>{{ form.sex }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  联系方式：
                  <span>{{ form.phone }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row class="chakanss">
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  报名状态：
                  <span>{{ xuanze1_1 }}</span>
                </div>
              </el-col>
            </el-row>
          </el-dialog>
          <div class="zsbg zsbg_1">
            <el-table :data="tableDatass" border style="width: 100%" @select="handleSelectionChanges" @select-all="fanxuans">
              <el-table-column type="selection" width="57" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="学员姓名" max-width="360">
                <template slot-scope="scope">
                  <el-link @click="chakan1(scope.row.id)">{{
                    scope.row.name
                  }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="phone" class="lianxi" label="联系方式">
                <template slot-scope="scope">
                  <el-link>{{ scope.row.phone }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="birthday" label="出生日期"></el-table-column>
              <el-table-column prop="enroll_time" label="报名时间"></el-table-column>
              <el-table-column prop="enroll_status" label="报名状态"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="stData">
                  <el-button type="text" class="caozuo" @click="getEnrollStudentById(stData.row.id)">编辑</el-button>
                  <el-button type="text" class="caozuo" @click="deleteEnrollStudent(stData.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="currentPages" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSizes"
            layout="total, sizes, prev, pager, next, jumper" :total="totals"></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'student',
  data() {
    return {
      orgname: '',
      orgnames: '',
      orgnamess: '',
      tableData: [],
      tableDatas: [],
      tableDatass: [],
      form: {
        name: '',
        enroll_status: '',
        sex: '1',
        phone: '',
        birthday: ''
      },
      form1: {},
      forms: {
        name: '',
        classid: '',
        sex: '1',
        phone: '',
        birthday: ''
      },
      forms1: {},
      jiaoshi: true,
      FormRules: {
        name: [{ required: true, message: '请您填写必填信息' }],
        classid: [{ required: true, message: '请您填写必填信息' }],
        phone: [
          { required: true, message: '请您填写必填信息' },
          { pattern: /^1[35789]\d{9}$/, message: '账号格式不对' }
        ]
      },
      FormRuless: {
        name: [{ required: true, message: '请您填写必填信息' }],
        phone: [
          { required: true, message: '请您填写必填信息' },
          { pattern: /^1[35789]\d{9}$/, message: '账号格式不对' }
        ]
      },
      xuanzezhuantai1: '选择状态',
      xuanzezhuantai1Code: '',
      xuanzebanji1: '选择班级',
      xuanzebanji1Id: '',
      baomingzhuantai1: '选择状态',
      baomingzhuantai1Code: '',
      xuanze1: '选择班级',
      xuanze1_1: '选择班级',
      xuanze3: '选择班级',
      xuanze4: '选择状态',
      xuanze5: '选择状态',
      lists: [],
      xuanzezhuantai: [],
      xuanzebanji: [],
      gridData: [],
      banji1: [],
      banji2: [],
      banji3: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 5,
      pageSizes: 5,
      currentPage: 1,
      currentPages: 1,
      total: 0,
      totals: 0,
      addStudents: false,
      addStudentss: false,
      addStudentsss: false,
      addStudentsss1: false,
      addEnrollStudents: false,
      addEnrollStudentss: false,
      yanse: '',
      yanse1: '',
      yanse2: '',
      yanse3: '',
      p(s) {
        return s < 10 ? '0' + s : s;
      },
      quanxuan: [],
      quanxuan1: '',
      quanxuans: [],
      quanxuan1s: '',

      str: '',
      accountForm: {
        photo: {
          icon: require('@/assets/img/education-manage/campus/logo.png')
        }
      }
    };
  },
  created() {
    this.studentQueryCondition();
    this.selectStudentPage();
    this.banji();
    this.selectEnrollStudentPage();
    this.studentEnrollCondition();

    // this.handleSelectionChange()
  },
  methods: {
    // 获得状态
    studentQueryCondition() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/student/studentQueryCondition',
        method: 'POST',
        data: {
          orgid: orgid
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.xuanzezhuantai = result.data.data.acountStatus;
          this.xuanzebanji = result.data.data.classList;
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得状态失败：' + err);
        });
    },

    // 获得学员列表
    selectStudentPage() {
      // console.log(this.orgnames)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: 'edu/student/selectStudentPage',
        method: 'POST',
        data: {
          orgid: orgid,
          classid: this.xuanzebanji1Id,
          name: this.orgnames,
          acount_status: this.xuanzezhuantai1Code,
          page: this.page,
          pageSize: this.pageSize
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          var data = result.data.data;
          this.tableData = data;
          if (data === undefined || data === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得学员列表失败：' + err);
        });
    },
    addStudent1() {
      this.addStudents = true;
      // this.banji()
    },
    addStudent() {
      const d = new Date(this.forms.birthday);
      this.forms.birthday = d.getFullYear() + '-' + this.p(d.getMonth() + 1) + '-' + this.p(d.getDate());
      // console.log(this.forms.birthday)
      // console.log(this.forms)
      this.$refs.forms.validate(valid => {
        if (!valid) {
          return false;
        }
        var that = this.forms;
        if (that.birthday === 'NaN-NaN-NaN') {
          this.$message.error('出生日期必填!');
          return false;
        }
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: 'edu/student/addStudent',
          method: 'POST',
          data: {
            name: that.name,
            classid: that.classid,
            sex: that.sex,
            org_id: orgid,
            birthday: that.birthday,
            phone: that.phone
          },
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.addStudents = false;
            this.selectStudentPage();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('新增学员失败：' + err);
          });
      });
    },
    banji() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/teacher/selectClassListByOrgid',
        method: 'POST',
        data: {
          orgid: orgid
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.banji1 = result.data.data;
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得班级失败：' + err);
        });
    },
    getStudentById(id) {
      // console.log(id)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/student/getStudentById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.addStudentss = true;
          this.forms1 = result.data.data;
          this.forms1.sex = JSON.stringify(this.forms1.sex);
          for (var i = 0; i < this.banji1.length; i++) {
            if (this.forms1.classid === this.banji1[i].id) {
              this.xuanze1 = this.banji1[i].name;
            }
          }
          if (this.xuanze1 !== '选择班级') {
            this.yanse3 = true;
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获取修改学员信息失败：' + err);
        });
    },
    updateStudent() {
      // console.log(this.forms1.classid)
      const d = new Date(this.forms1.birthday);
      this.forms1.birthday = d.getFullYear() + '-' + this.p(d.getMonth() + 1) + '-' + this.p(d.getDate());
      this.$refs.forms.validate(valid => {
        if (!valid) {
          return false;
        }
        var that = this.forms1;
        if (that.birthday === 'NaN-NaN-NaN') {
          this.$message.error('出生日期必填!');
          return false;
        }
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: 'edu/student/updateStudent',
          method: 'POST',
          data: {
            id: that.id,
            name: that.name,
            classid: that.classid,
            sex: that.sex,
            org_id: orgid,
            birthday: that.birthday,
            phone: that.phone
          },
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.addStudentss = false;
            this.selectStudentPage();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('修改学员失败：' + err);
          });
      });
    },
    deleteStudent(id) {
      // console.log(id)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let pro = this.$http({
          url: '/edu/student/deleteStudent/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.selectStudentPage();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('删除学员信息失败：' + err);
          });
      });
    },
    quxiao() {
      if (this.addStudents) {
        this.addStudents = false;
      }
      if (this.addStudentss) {
        this.addStudentss = false;
      }
    },
    chakan(id) {
      // console.log(id)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/student/getStudentById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.addStudentsss = true;
          this.form = result.data.data;
          if (this.form.sex === 0) {
            this.form.sex = '女';
          } else if (this.form.sex === 1) {
            this.form.sex = '男';
          }
          for (var i = 0; i < this.banji1.length; i++) {
            if (this.form.classid === this.banji1[i].id) {
              this.xuanze1 = this.banji1[i].name;
            }
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获取学员信息失败：' + err);
        });
    },
    guanli(e) {
      // console.log(e)
      this.xuanze3 = e.name;
      this.forms.classid = e.id;
      if (this.xuanze3 !== '选择班级') {
        this.yanse2 = true;
      }
    },
    guanli_1(e) {
      // console.log(e)
      this.xuanze4 = e.name;
      this.form.enroll_status = e.code;
      if (this.xuanze4 !== '选择状态') {
        this.yanse1 = true;
      }
    },
    guanli1(e) {
      // console.log(e)
      this.xuanze1 = e.name;
      this.forms1.classid = e.id;
    },
    guanli1_1(e) {
      // console.log(e)
      this.xuanze5 = e.name;
      this.form1.enroll_status = e.code;
    },
    guanli2(e) {
      // console.log(e)
      this.xuanzezhuantai1Code = e.code;
      this.xuanzezhuantai1 = e.name;
      this.selectStudentPage();
    },
    guanli2_1(e) {
      // console.log(e)
      this.baomingzhuantai1Code = e.code;
      this.baomingzhuantai1 = e.name;
      this.selectEnrollStudentPage();
    },
    guanli3(e) {
      // console.log(e)
      this.xuanzebanji1Id = e.id;
      this.xuanzebanji1 = e.name;
      this.selectStudentPage();
    },
//删除
    dels() {
      if (this.quanxuan.length === 0) {
        return this.$message.error('请选择要删除的数据');
      } else {
        for (var i = 0; i < this.quanxuan.length; i++) {
          this.quanxuan1 = this.quanxuan
            .map(function(elem, index) {
              return elem.id;
            })
            .join('&#');
        }
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: 'edu/student/deleteStudentBatch',
        method: 'POST',
        data: {
          ids: this.quanxuan1
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.selectStudentPage();
          return this.$message.success(result.data.message);
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得批量删除失败：' + err);
        });
    },
    handleSelectionChange(val) {
      // console.log(val)
      this.quanxuan = val;
    },
    fanxuan(val) {
      // console.log(val)
      this.quanxuan = val;
    },
//批量删除
    del1s() {
      if (this.quanxuans.length === 0) {
        return this.$message.error('请选择要删除的数据');
      } else {
        for (var i = 0; i < this.quanxuans.length; i++) {
          this.quanxuan1s = this.quanxuans
            .map(function(elem, index) {
              return elem.id;
            })
            .join('&#');
        }
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: 'edu/student/deleteEnrollStudentBatch',
        method: 'POST',
        data: {
          ids: this.quanxuan1s
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.selectEnrollStudentPage();
          return this.$message.success(result.data.message);
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得批量删除失败：' + err);
        });
      // console.log(this.quanxuan1)
      // console.log(this.quanxuan)
    },
    handleSelectionChanges(val) {
      // console.log(val)
      this.quanxuans = val;
    },
    fanxuans(val) {
      // console.log(val)
      this.quanxuans = val;
    },

    // 获得报名学员列表
    selectEnrollStudentPage() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: 'edu/student/selectEnrollStudentPage',
        method: 'POST',
        data: {
          orgid: orgid,
          name: this.orgnamess,
          enroll_status: this.baomingzhuantai1Code,
          page: this.page,
          pageSize: this.pageSize
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          var data1 = result.data.data;
          this.tableDatass = data1;
          if (data1 === undefined || data1 === null) {
            this.totals = 0;
          } else {
            this.totals = result.data.size;
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得报名学员列表失败：' + err);
        });
    },

    // 新增报名学员
    addEnrollStudent() {
      const d = new Date(this.form.birthday);
      this.form.birthday = d.getFullYear() + '-' + this.p(d.getMonth() + 1) + '-' + this.p(d.getDate());
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false;
        }
        var that = this.form;
        if (that.birthday === 'NaN-NaN-NaN') {
          this.$message.error('出生日期必填!');
          return false;
        }
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: 'edu/student/addEnrollStudent',
          method: 'POST',
          data: {
            name: that.name,
            enroll_status: that.enroll_status,
            sex: that.sex,
            org_id: orgid,
            birthday: that.birthday,
            phone: that.phone
          },
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.addEnrollStudents = false;
            this.selectEnrollStudentPage();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('新增报名学员失败：' + err);
          });
      });
    },

    chakan1(id) {
      // console.log(id)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/student/getEnrollStudentById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.addStudentsss1 = true;
          this.form = result.data.data;
          if (this.form.sex === 0) {
            this.form.sex = '女';
          } else if (this.form.sex === 1) {
            this.form.sex = '男';
          }
          for (var i = 0; i < this.banji3.length; i++) {
            if (this.form.enroll_status === this.banji3[i].code) {
              this.xuanze1_1 = this.banji3[i].name;
            }
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获取报名学员信息失败：' + err);
        });
    },

    // 获得报名状态
    studentEnrollCondition() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/student/studentEnrollCondition',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.banji3 = result.data.data.enrollStatus;
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得班级失败：' + err);
        });
    },
    quxiao1() {
      if (this.addEnrollStudents) {
        this.addEnrollStudents = false;
      }
      if (this.addEnrollStudentss) {
        this.addEnrollStudentss = false;
      }
    },

    // 获取修改报名学员信息
    getEnrollStudentById(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/student/getEnrollStudentById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.addEnrollStudentss = true;
          this.form1 = result.data.data;
          this.form1.sex = JSON.stringify(this.form1.sex);
          for (var i = 0; i < this.banji3.length; i++) {
            if (this.form1.enroll_status === this.banji3[i].code) {
              this.xuanze5 = this.banji3[i].name;
            }
          }
          if (this.xuanze5 !== '选择状态') {
            this.yanse = true;
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获取修改报名学员信息失败：' + err);
        });
    },

    // 修改报名学员
    updateEnrollStudent() {
      // console.log(this.forms1.classid)
      const d = new Date(this.form1.birthday);
      this.form1.birthday = d.getFullYear() + '-' + this.p(d.getMonth() + 1) + '-' + this.p(d.getDate());
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false;
        }
        var that = this.form1;
        if (that.birthday === 'NaN-NaN-NaN') {
          this.$message.error('出生日期必填!');
          return false;
        }
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: 'edu/student/updateStudent',
          method: 'POST',
          data: {
            id: that.id,
            name: that.name,
            enroll_status: that.enroll_status,
            sex: that.sex,
            org_id: orgid,
            birthday: that.birthday,
            phone: that.phone
          },
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.addEnrollStudentss = false;
            this.selectEnrollStudentPage();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('修改报名学员失败：' + err);
          });
      });
    },
    deleteEnrollStudent(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let pro = this.$http({
          url: '/edu/student/deleteEnrollStudent/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.selectEnrollStudentPage();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('删除报名学员信息失败：' + err);
          });
      });
    },
    addEnrollStudent1() {
      this.addEnrollStudents = true;
      this.studentEnrollCondition();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      this.selectStudentPage();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.selectStudentPage();
    },
    handleSizeChange1(val) {
      this.pageSizes = val;
      this.page = 1;
      this.currentPages = 1;
      this.selectEnrollStudentPage();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.selectEnrollStudentPage();
    }
  }
};
</script>

<style lang="less">
.mains {
  .campus {
    // width: 28px;
    // height: 20px;
    font-family: PingFang SC;
    font-size: 14px;
    color: #666666ff;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 10px;
    span {
      margin: 0 10px 0 8px;
    }
  }
  .zt1 {
    color: #000 !important;
  }
  .xiaoqu {
    margin-bottom: 20px;
  }
  .xiaoqu .grid-content .el-dialog .form_1_1 .xingbie {
    position: absolute;
    top: 6.85vw;
    right: 3.22917vw;
    i {
      img {
        margin-left: 25px;
      }
    }
  }
  .xiaoqu .grid-content .el-dialog .form_1_1 .el-form-item .student_dropdown .el-button--primary {
    width: 7.20833vw;
  }
  .xiaoqu .grid-content .el-dialog .form_1_1 .el-form-item .el-input__inner {
    color: #000;
  }
  .xiaoqu .grid-content .zsbg_1 .el-table {
    .el-table_1_column_1 {
      padding-left: 2% !important;
    }
    .el-table_1_column_2 {
      padding-left: 5% !important;
    }
    .el-table_1_column_3 {
      text-align: left;
      padding-left: 4% !important;
    }
    .el-table_2_column_9 {
      text-align: left;
      padding-left: 2% !important;
    }
    .el-table_2_column_10 {
      text-align: left;
      padding-left: 5% !important;
    }
    .el-table_2_column_11 {
      text-align: left;
      padding-left: 3% !important;
    }
  }
  .lianxi {
    color: #00a6e6;
  }

  .xzbz {
    i {
      position: fixed !important;
      right: 320px;
      top: 147px;
    }
  }
  .chushen {
    .el-icon-date:before {
      content: '';
    }
  }
}
.student_dropdown .el-dropdown-menu__item {
  width: 6.375vw;
}
.student_zhuantai {
  position: relative;
  // top: 10.83333vw !important;
  left: 1104px !important;
}
.student_zhuantai1 {
  position: relative;
  // top: 25vw !important;
  left: 67.96875vw !important;
}
</style>
